<mat-chip [disableRipple]="true"
          class="!tw-bg-lendio-blue-400"
          *ngIf="applicationComplete"
          [matTooltip]="appCompleteTooltip"
          matTooltipPosition="above">
  <span class="tw-text-white">App Complete</span>
</mat-chip>
